module.exports = __webpack_public_path__ + "img/logo-visa.a47a87e0.png";